<template>
  <div>
    <!-- 설명 -->
    <p class="mb-5" style="color: #4839EB;">※ 8대 위험요인(사다리/비계, 지붕, 고소작업대, 방호장치, 혼재작업, 충돌방지 장치, LOTO)에 대한 위험성은 필히 반영</p>

    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'field_name', 'date',]"
      :mobile-types="['field_name']"
      :typeslabel="{
        com_name: '학교명',
      }"
    />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 위험성평가 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>공정 또는 작업명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly"/>
        </div>
        <div>
          <div>평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly"/>
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 수시 위험성평가 -->
    <table-risk-appraisal589
      class="mt-5"
      title="수시 위험성평가"
      v-model="form.riskAppraisalList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      :hide-code-number="true"/>

    <!-- 확인자 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>담당</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>검토</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>승인</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import TableRiskAppraisal589 from "@/views/boards/single-page/589/TableRiskAppraisal589.vue";

export default {
  components: {
    TableRiskAppraisal589,
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.riskAppraisalList': {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.disasterList = value.map((item) => item.input_3);
        this.form.disasterString = this.form.disasterList.toString()
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        riskAppraisalList: [
          {
            "id": 1,
            "input_check": false,
            "input_1": "사다리 사용 작업",
            "input_2": "평판하지 않고 무른 바닥에 사다리를 설치하여 지지대가 기울어짐",
            "input_3": "사다리 작업 SOP 적용 수시 교육\n" +
              "   - 설치 높이별 사다리 사용 기준\n",
            "input_4": "현재의 지침/기준 유지",
            "input_5": "",
            "input_6": "",
            "input_7": ""
          },
          {
            "id": 2,
            "input_check": false,
            "input_1": "사다리 사용 작업",
            "input_2": "전도 방지대가 설치된 사다리였으나\n" +
              "전도방지대를 펼치지 않고 작업하여 사다리 기울어짐을 예방하지 못함",
            "input_3": "설치높이 3.5m 이상 작업 발생시 관리자 현장 방문 공사 상태 점검 실시",
            "input_4": "현재의 지침/기준 유지",
            "input_5": "",
            "input_6": "",
            "input_7": ""
          },
          {
            "id": 3,
            "input_check": false,
            "input_1": "고소장비 사용 작업",
            "input_2": "설치높이 3.5m 이상 고소 작업\n" +
              "안전대 체결 불가건으로 고소장비 사용 \n" +
              "계획이 예정되어 있었으나 임의 작업",
            "input_3": "설치높이 3.5m 이상 안전대 체결 불가시 고소장비 사용 작업 지침 적용",
            "input_4": "사고사례전파 교육 진행\n" +
              "  - 사다리 작업 기준 준수 \n" +
              "  - 작업공정(일정) 준수 \n" +
              "  - 고소작업 발생 시 작업기준 준수",
            "input_5": "",
            "input_6": "",
            "input_7": ""
          },
        ],

        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
